import PromotionCodeAdapter from '../../adapters/promotionCode';

const SELECTOR = {
  inputPromotionRow: '.booking-promotion__line-item',
  inputPromotionCode: '.booking-promotion__input__code',
  inputPromotionPrice: '.booking-promotion__input__price',
  inputPromotionSubmit: '.booking-promotion__submit',
  discountText: '.booking-promotion__line-discount',
  totalPrice: '.booking-summary__total_price'
};

class CheckPromotion {
  constructor() {
    // this.inputPromotionSubmit = document.querySelector(SELECTOR['inputPromotionSubmit']);
    this.inputPromotionCode = document.querySelector(SELECTOR['inputPromotionCode']);

    this._addEventListeners();
  }

  // Event Handlers

  async checkPromotionCode(event) {
    const inputPromotionCode = document.querySelector(SELECTOR['inputPromotionCode']).value;
    const inputPromotionPrice = document.querySelector(SELECTOR['inputPromotionPrice']).value;
    const responsePromotionCode = await PromotionCodeAdapter.get(inputPromotionCode, inputPromotionPrice);
    const input = document.getElementById('promotion_code');

    if (responsePromotionCode && responsePromotionCode.id) {
      document.querySelector('#booking_promotion_id').value = responsePromotionCode.id;
      document.querySelectorAll(SELECTOR['discountText']).innerHTML = `
        <td><span style="color: #00ca9f">Discount</span></td>
        <td class='booking-summary__total_price'><span style="color: #00ca9f">${responsePromotionCode.discount_price}</span></td>`;
      input.className = 'booking-promotion__input__code';
      input.readOnly = true;
    } else {
      document.querySelectorAll(SELECTOR['discountText']).innerHTML = '';
      input.className = 'booking-promotion__input__code invalid';
      input.readOnly = true;
    }

    document.querySelector(SELECTOR['totalPrice']).innerHTML = `${responsePromotionCode.price}`;
  }

  // Private Methods

  _addEventListeners() {
  }
}

export default CheckPromotion;



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/checkPromotion/index.js